export default "__VITE_ASSET__461a8bdc__"